module.exports = __webpack_public_path__ + "static/dethek_dwarvish_table_1-61e847f2951667035bad329fc7b94aeb.png";